<template>
  <div class="apps-container">
    <div class="apps-section" v-for="(section, sIndex) in sections" :key="sIndex">
      <div class="section-title">
        <i class="bar"></i>
        <span>{{ section.title }}</span>
      </div>
      <div class="apps-grid">
        <div class="app-card" v-for="(app, aIndex) in section.items" :key="aIndex" @click="open(app)">
          <div class="app-icon">
            <img :src="getIcon(app.icon)" alt="icon" />
          </div>
          <div class="app-info">
            <div class="app-name">{{ app.name }}</div>
            <div class="app-desc">{{ app.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApps } from '@/config/user_app_config'
export default {
  name: 'SystemApps',
  data() {
    return {
      allSections: [
        {
          title: '应用功能',
          items: [
            { name: '上门回收', desc: '上门回收服务，支持自定义工单', icon: '切图 48@2x.png' },
            { name: '便民驿站', desc: '便民服务入口', icon: '切图 51@2x.png' },
            { name: '分拣中心', desc: '从业人员管理统计', icon: '切图 55@2x.png' }
          ]
        }
      ]
    }
  },
  computed: {
    sections() {
      return this.allSections
    }
  },
  methods: {
    getUsername() {
      const s = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.userInfo
      return (s && s.username) || localStorage.getItem('username') || ''
    },
    getOverrides() {
      try {
        const raw = localStorage.getItem('user_apps_override') || '{}'
        const obj = JSON.parse(raw)
        return typeof obj === 'object' && obj ? obj : {}
      } catch (e) {
        return {}
      }
    },
    saveOverrides(overrides) {
      try {
        localStorage.setItem('user_apps_override', JSON.stringify(overrides || {}))
      } catch (e) { void 0 }
    },
    isEnabled(appName) {
      const username = this.getUsername()
      const overrides = this.getOverrides()
      if (Object.prototype.hasOwnProperty.call(overrides, username)) {
        const arr = Array.isArray(overrides[username]) ? overrides[username] : []
        return arr.includes(appName)
      }
      const defaults = userApps[username] || []
      return defaults.includes(appName)
    },
    async open(app) {
      const name = app && app.name ? app.name : ''
      if (!name) return
      const enabled = this.isEnabled(name)
      const action = enabled ? '关闭' : '开启'
      try {
        await this.$confirm(`是否${action}「${name}」应用？`, '提示', { confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning' })
      } catch (e) {
        return
      }
      const username = this.getUsername()
      const overrides = this.getOverrides()
      const arr = Array.isArray(overrides[username]) ? overrides[username] : (userApps[username] ? [...userApps[username]] : [])
      const idx = arr.indexOf(name)
      if (enabled && idx >= 0) {
        arr.splice(idx, 1)
      } else if (!enabled && idx === -1) {
        arr.push(name)
      }
      overrides[username] = arr
      this.saveOverrides(overrides)
      window.dispatchEvent(new CustomEvent('user-apps-updated', { detail: { username, apps: arr } }))
      this.$message.success(`${action}成功`)
    },
    getIcon(file) {
      try {
        return require(`@/assets/yingyong/${file}`)
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.apps-container { padding: 16px; }
.section-title { display: flex; align-items: center; margin: 16px 0 8px; font-weight: 600; color: #303133; }
.section-title .bar { width: 6px; height: 16px; background: #67C23A; border-radius: 2px; margin-right: 8px; }
.apps-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.app-card { display: flex; align-items: center; background: #fff; border: 1px solid #ebeef5; border-radius: 6px; padding: 10px; cursor: pointer; }
.app-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.app-icon img { width: 40px; height: 40px; border-radius: 6px; }
.app-info { margin-left: 10px; }
.app-name { color: #303133; font-size: 14px; font-weight: 600; }
.app-desc { color: #909399; font-size: 12px; margin-top: 4px; }
@media (max-width: 1280px) { .apps-grid { grid-template-columns: repeat(2, 1fr); } }
</style>
